module.exports = __webpack_public_path__ + "img/epr-price.3b3afa71.webp";